import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import SvgIcon from '@material-ui/core/SvgIcon';
import { withNamespaces, WithNamespaces } from 'react-i18next';


const Hills: React.FunctionComponent<WithNamespaces> = ({ t }) => {
    return (
        <IconButton aria-label="hills">
            <SvgIcon viewBox="0 -5 39 39" preserveAspectRatio="xMinYMin meet">
                <title>{t('icons.hills')}</title>
                <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="2.0.4-Full-Screen-MOTORWAY" transform="translate(-152.000000, -23.000000)" fill="#FFFFFF">
                        <g id="Icon_Hills" transform="translate(152.000000, 23.000000)">
                            <path d="M30.8466667,7.9236619 C30.164,6.45637058 28.968,5.08217817 27.2493333,5.08086691 C25.4866667,5.07824441 24.264,6.19149761 23.4653333,7.9236619 L14.3933333,27.5806452 L40,27.5806452 L30.8466667,7.9236619 Z M13.3933333,27.5806452 L0,27.5806452 L10.8853333,3.9925275 C11.8453333,1.91419261 13.3106667,0.57802651 15.4266667,0.580649015 C17.488,0.583271519 18.924,2.23151566 19.744,3.9925275 L22.0213333,8.88480984 L13.3933333,27.5806452 Z" id="Shape"></path>
                        </g>
                    </g>
                </g>
            </SvgIcon>
        </IconButton>
    );
}

export default withNamespaces()(Hills);